class CollectionNavigation extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-collection-navigation-list]');
    this.progress = this.querySelector('[data-collection-navigation-progress]');
    this.thumb = this.querySelector('[data-collection-navigation-thumb]');

    if (!this.list || !this.progress || !this.thumb) return;

    this.updateProgress = this.updateProgress.bind(this);
    this.list.addEventListener('scroll', this.updateProgress, { passive: true });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateProgress);
      this.resizeObserver.observe(this.list);
    } else {
      window.addEventListener('resize', this.updateProgress, { passive: true });
    }

    requestAnimationFrame(this.updateProgress);
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.updateProgress);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.updateProgress);
  }

  updateProgress() {
    const scrollableWidth = Math.max(0, this.list.scrollWidth - this.list.clientWidth);

    if (scrollableWidth < 2) {
      this.progress.hidden = true;
      this.thumb.style.left = '0%';
      this.thumb.style.width = '100%';
      return;
    }

    this.progress.hidden = false;

    const visibleRatio = this.list.clientWidth / this.list.scrollWidth;
    const thumbWidth = Math.max(18, Math.min(100, visibleRatio * 100));
    const scrollRatio = Math.max(0, Math.min(1, this.list.scrollLeft / scrollableWidth));
    const thumbPosition = scrollRatio * (100 - thumbWidth);

    this.thumb.style.width = `${thumbWidth}%`;
    this.thumb.style.left = `${thumbPosition}%`;
  }
}

if (!customElements.get('collection-navigation')) {
  customElements.define('collection-navigation', CollectionNavigation);
}
